import { TipsMapFunType, TipsMapType } from '@op/components/BubbleCommon';
import { transRegion } from '@op/utils';
import React from 'react';
export const hashtagMapFullTipsMap: TipsMapType = {
  en: `View chart in full screen`,
  zh: `全屏查看图表`,
};

export const hashtagTop5DetailTipsMap: TipsMapType = {
  en: `No hashtag data available for other key countries during the selected period`,
  zh: `当前时段其他重点国家暂无该Hashtag数据`,
};

export const hashtagCountryDistributionTop5DetailTipsMap: TipsMapFunType = (
  countries: Array<string>,
) => {
  return {
    zh: (
      <>
        Hashtag数据来源于TikTok平台，仅提供以下国家的统计数据:
        <br />
        <span>{countries.map((item) => transRegion(item, 4)).join(', ')}</span>
      </>
    ),
    en: (
      <>
        Hashtag data is sourced from the TikTok platform, and statistics are
        only available for the following countries:
        <br />
        <span>{countries.map((item) => transRegion(item, 2)).join(', ')}</span>
      </>
    ),
  };
};

export const hashtagDetailNoCategoryTipsMap: TipsMapType = {
  en: `The TikTok platform does not provide this hashtag category`,
  zh: `TIktok平台未提供该hashtag分类`,
};

export const hashtagRankTitleTipsMap: TipsMapType = {
  en: `Ranking data is obtained via the TikTok API`,
  zh: `排序数据通过Tiktok接口获得`,
};

export const hashtagTrendTitleTipsMap: TipsMapType = {
  en: `Used to view the popularity trend of a hashtag. The indicator data has no practical meaning and cannot be compared across hashtags.`,
  zh: `用于查看Hashtag的热度变化走势，指标数据没有实际意义，不可跨hashtag比较`,
};

export const hashtagHeaderTipsMap: TipsMapType = {
  en: (
    <>
      Use filters to explore the Top 100 Hashtags by country and category.{' '}
      <br />
      Data source: TikTok platform <br />
      Update frequency: Twice daily (morning and evening), with same-day data
      availability (T+0)
    </>
  ),
  zh: (
    <>
      支持筛选查看指定国家及品类下的Top100Hashtag榜单。
      <br />
      数据来源：TikTok平台
      <br />
      更新频率：每日早晚各一次，数据当日更新（T+0）
    </>
  ),
};


export const hashtagClickTitleTipsMap: TipsMapType = {
  en: `Click to visit the source website`,
  zh: `点击跳转源网站`,
};
  